// Reset Password script
import './reset-password-page';